// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "core_pricing_external_id",
                Decco.stringToJson(v.core_pricing_external_id)
              ],
              [
                "prioritized_modification_ids",
                Decco.listToJson(Decco.stringToJson, v.prioritized_modification_ids)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
